import {Component, Input, OnInit} from '@angular/core';
import {
    BaseStepperFormComponent,
    Feature,
    Features,
    LoadingService,
    Organization,
    OrganizationRole,
    OrganizationRoleService
} from 'brewbill-lib';
import {ModalController} from '@ionic/angular';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'bb-edit-organization-role',
    templateUrl: './edit-organization-role.component.html',
    styleUrls: ['./edit-organization-role.component.scss'],
})
export class EditOrganizationRoleComponent extends BaseStepperFormComponent implements OnInit {
    @Input() organizationRole: OrganizationRole;
    @Input() organization: Organization;

    features = [];
    itemFilter = '';
    filteredItems: { feature: Feature, selected: boolean }[];
    formGroup: FormGroup;

    constructor(
        modalController: ModalController,
        private organizationRoleService: OrganizationRoleService,
        private loadingService: LoadingService,
        private formBuilder: FormBuilder
    ) {
        super(modalController);
    }

    ngOnInit() {
        const tmpFeatures = Features.filter(f => !f.global).sort((a, b) => a.description.localeCompare(b.description));
        tmpFeatures.forEach(feature => {
            this.features.push({
                feature,
                selected: !!this.organizationRole.features && this.organizationRole.features.some(f => f.key === feature.key)
            });
        });

        this.formGroup = this.formBuilder.group({
            id: this.organizationRole.id,
            parentId: this.organization.id,
            name: [this.organizationRole.name, [Validators.required, Validators.maxLength(250)]],
            description: [this.organizationRole.description, Validators.maxLength(2000)]
        });
    }

    filterItems(items: any[], filter: string) {
        return !!filter && !!items ? items.filter(item => item.feature.description.toLowerCase()
            .includes(filter.toLowerCase())) : items;
    }

    onSubmit() {
        const role = new OrganizationRole(this.formGroup.value);
        role.features = this.features.filter(f => f.selected).map(f => f.feature);

        this.loadingService.present();

        if (role.id != null) {
            this.organizationRoleService.update(role).subscribe((p) => {
                    this.loadingService.dismiss();
                    this.close(role);
                }
            );
        } else {
            this.organizationRoleService.create(role).subscribe((p) => {
                    this.loadingService.dismiss();
                    this.close(role);
                }
            );
        }
    }
    valid() {
        return this.formGroup.valid;
    }
}
